import React, { ReactNode, Ref } from "react";
import styled from "styled-components";
import styles from "./PeopleSearchLayout.module.scss";

type PeopleSearchLayoutProps = {
  navigation: ReactNode;
  mobileNavigation?: ReactNode;
  breadcrumbs: ReactNode;
  hero: ReactNode;
  heroClassName?: string;
  filters: ReactNode;
  results: ReactNode;
  mobileActions?: ReactNode;
  shouldHideNavigation?: boolean;
  filtersRef?: Ref<HTMLDivElement>;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  max-width: 150rem;
  margin: auto;

  @media (max-width: 900px) {
    padding-right: 0;
    padding-left: 0;
  }

  @media (max-width: 600px) {
    padding-right: 0;
    padding-left: 0;
  }
`;

const OverflowContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 2rem;

  @media (max-width: 900px) {
    padding: 6rem 2rem 2rem 2rem;
  }

  @media (max-width: 600px) {
    padding: 6rem 2rem 2rem 2rem;
  }
`;

const PeopleSearchLayout = ({
  navigation,
  mobileNavigation,
  breadcrumbs,
  hero,
  heroClassName,
  filters,
  results,
  mobileActions,
  shouldHideNavigation,
  filtersRef,
}: PeopleSearchLayoutProps) => {
  return (
    <Container>
      {!shouldHideNavigation && navigation}
      {shouldHideNavigation && mobileNavigation}
      <OverflowContainer>
        {mobileActions && <div className={styles.mobileActions}>{mobileActions}</div>}
        <div className={styles.breadcrumbs}>{breadcrumbs}</div>
        <div className={`${styles.hero} ${heroClassName || ""}`.trim()}>
          {hero}
        </div>
        <div className={styles.content}>
          <aside className={styles.filters} ref={filtersRef}>
            {filters}
          </aside>
          <div className={styles.results}>{results}</div>
        </div>
      </OverflowContainer>
    </Container>
  );
};

export default PeopleSearchLayout;

